<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <h5 class="mb-0 text-primary">{{ workoutGroup.name }}</h5>
      </div>
      <div class="">
        <a @click.prevent="openEditModal()" href="#" title="Edit exercise group properties">
          <i class="mdi mdi-24px mdi-pencil" style="line-height:24px;"></i>
        </a>
        <a @click.prevent="openSortModal()" href="#" title="Sort the exercises in this exercise group" v-if="workoutGroup.exercises.length>1">
          <i class="mdi mdi-24px mdi-sort" style="line-height:24px;"></i>
        </a>
        <!-- <a @click.prevent="removeWorkoutExerciseGroup()" href="#" title="Remove this exercise group">
          <i class="mdi mdi-24px mdi-delete" style="line-height:24px;"></i>
        </a> -->
      </div>
    </div>
    <div v-if="workoutGroup.description"
      class="alert alert-light p-1 m-0 border-light"
      style="white-space: pre-wrap"
      v-text="workoutGroup.description">
    </div>
    <table :class="{ loading: false }" class="table table-xs table-hover">
      <thead class="thead-light">
        <tr>
          <th scope="col"></th>
          <th scope="col">Exercise</th>
          <th class="text-right" scope="col">Sets</th>
          <th class="text-right" scope="col">Reps</th>
          <th class="text-right" scope="col">Rest</th>
        </tr>
      </thead>
      <tbody :exercises="workoutGroup.exercises" @exercise-updated="exerciseUpdated" is="WorkoutPlanPanelExerciseGroupExercise"></tbody>
      <tfoot>
        <tr>
          <td></td>
          <td><a href="#" @click.prevent="openAddExerciseModal()"><i class="mdi mdi-plus"></i>Add Exercise</a></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <!-- <td class="text-right">{{ totalSets || '' }}</td>
          <td class="text-right">{{ totalReps || '' }}</td>
          <td class="text-right">{{ totalRest }}s</td> -->
        </tr>
      </tfoot>
    </table>

    <!-- <div class="alert border-info alert-info w-100" v-if="hasFoods && !mealSettingExists">
        This Meal Setting does not exist! Create it?<br>
        <a class="btn btn-sm btn-secondary" target="_blank" :href="createMealSettingLink">Create Meal Setting <i class="mdi mdi-open-in-new"></i></a>
    </div>-->

    <modal @close="closeAddExerciseModal()" v-if="showAddExerciseModal">
      <h3 slot="header">Add {{ ExerciseToAdd ? ExerciseToAdd.name : 'Exercise' }}</h3>
      <div slot="body">
        <div v-show="!ExerciseToAdd">
          <input class="form-control mb-2" id="exercise_list_filter" placeholder="Filter" ref="exercise_filter_input" required type="text" v-model="exercise_list_filter"/>
          <div class="form-group form-check">
            <!-- <input class="form-check-input" id="show_only_chosen_foods" type="checkbox" v-model="show_only_chosen_foods"/> -->
            <!-- <label class="form-check-label" for="show_only_chosen_foods">Show only chosen foods</label> -->
          </div>
        </div>

        <dl v-show="!ExerciseToAdd">
          <template v-bind="index" v-for="(exercise, index) in filteredExercisesSorted">
            <dt :class="{'text-muted': false}" v-bind:key="(index+'dt')">
              <a @click.prevent="chooseExerciseToAdd(exercise)" href="#">{{ exercise.name }}</a>
            </dt>
            <dd style="margin-left:1rem;" v-bind:key="(index+'dd')">{{ exercise.description }}</dd>
          </template>
        </dl>
        <div v-if="ExerciseToAdd">
          <form @submit.prevent="addExercise()">
            <div class="form-row align-items-center mb-2">
              <div class="form-group col">
                <label for="exercise-to-add-sets">Sets</label>
                <input
                  class="form-control"
                  placeholder="#"
                  id="exercise-to-add-sets"
                  min="1"
                  max="255"
                  step="1"
                  type="number"
                  required
                  v-model.number="exerciseToAddDetails.sets"
                />
              </div>
              <div class="form-group col">
                <label for="exercise-to-add-reps">Reps</label>
                <input
                  class="form-control"
                  placeholder="#"
                  id="exercise-to-add-reps"
                  min="1"
                  max="255"
                  step="1"
                  type="number"
                  required
                  v-model.number="exerciseToAddDetails.reps"
                />
              </div>
              <div class="form-group col-2">
                <label for="exercise-to-add-rep-unit">Rep Unit</label>
                <select class="form-control" id="exercise-to-add-rep-unit" required v-model="exerciseToAddDetails.rep_unit">
                  <option value="x">x</option>
                  <option value="ea">ea</option>
                  <option value="sec">sec</option>
                  <option value="min">min</option>
                </select>
              </div>
              <div class="form-group col">
                <label for="exercise-to-add-rest">Rest (s)</label>
                <input
                  class="form-control"
                  placeholder=""
                  id="exercise-to-add-rest"
                  min="0"
                  max="255"
                  type="number"
                  required
                  v-model.number="exerciseToAddDetails.rest"
                />
              </div>
            </div>
            <div class>
              <button :disabled="!exerciseToAddDetailsValid" type="submit" class="btn btn-primary">Add Exercise</button>
              <button @click="ExerciseToAdd=null;exerciseToAddDetails={};" class="btn btn-default">Change Exercise</button>
            </div>
          </form>
        </div>
      </div>
      <div slot="footer">
        <button @click="closeAddExerciseModal()" class="btn btn-default">Cancel</button>
      </div>
    </modal>

    <modal @close="closeSortModal()" v-if="showSortModal">
      <h3 slot="header">Sort Exercises</h3>
      <div slot="body">
        <div v-if="!sortedExercises.length" class="alert alert-danger">No exercises to sort!</div>
        <div v-if="sortedExercises.length">Drag exercises to sort them.</div>
        <table class="table table-xs table-hover table-striped" v-if="sortedExercises.length">
          <thead class="thead-light">
            <tr>
              <th scope="col"></th>
              <th scope="col">Exercise</th>
              <th class="text-right" scope="col">Sets</th>
              <th class="text-right" scope="col">Reps</th>
              <th class="text-right" scope="col">Rest</th>
            </tr>
          </thead>
          <tbody is="draggable" v-model="sortedExercises" handle="tr" tag="tbody" @change="sortChanged">
            <tr v-for="(exercise, index) in sortedExercises" v-bind:key="index">
              <td class="align-middle">
                <i class="mdi mdi-drag mdi-18px handle" v-if="workoutGroup.exercises.length>1"></i>
              </td>
              <td class="align-middle">{{ exercise.name }}</td>
              <td class="align-middle text-right" >{{ exercise.pivot.sets }}</td>
              <td class="align-middle text-right" >{{ exercise.pivot.reps }}</td>
              <td class="align-middle text-right" ></td>
              <!-- <td class="align-middle text-right" >{{ exercise.pivot.rest }}s</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <button @click="closeSortModal()" class="btn btn-default">Cancel</button>
        <button @click="updateSorting()" class="btn btn-primary" v-if="sortIsDirty">Save</button>
      </div>
    </modal>

    <form-modal @close="closeEditModal()" v-if="showEditModal" @submitted="updateExerciseGroup">
      <h3 slot="header">Edit Exercise Group: {{ workoutGroup.name }}</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="form-group col-md-4">
            <label for="workout-group-edit-name">Name</label>
          </div>
          <div class="form-group col-md-8">
            <input
              class="form-control"
              placeholder="Name"
              id="workout-group-edit-name"
              type="text"
              required
              v-model="newExerciseGroupDetails.name"
            />
          </div>
        </div>
        <div class="form-row align-items-center mb-2">
          <div class="form-group col-md-4">
            <label for="workout-group-edit-description">Description</label>
          </div>
          <div class="form-group col-md-8">
            <textarea
              class="form-control"
              placeholder="Description"
              id="workout-group-edit-description"
              v-model="newExerciseGroupDetails.description"
            />
          </div>
        </div>
      </div>
      <template slot="footer">
        <vueConfirmationButton
          :messages="['Delete', 'Are you sure?', 'Deleting!']"
          icon_css="mdi mdi-delete"
          css="btn btn-danger mr-auto"
          v-on:confirmation-success="removeWorkoutExerciseGroup()"
        />
        <!-- <button @click="removeWorkoutExerciseGroup()" class="btn btn-danger mr-auto" title="Remove this exercise group">
          <i class="mdi mdi-delete"></i> Delete
        </button> -->
        <button type="reset" @click="closeEditModal()" class="btn btn-default">Cancel</button>
        <button type="submit" class="btn btn-primary" v-if="editIsDirty">Save</button>
      </template>
    </form-modal>
  </div>
</template>
<script>
import WorkoutPlanPanelExerciseGroupExercise from '@coach/js/components/WorkoutPlanPanelExerciseGroupExercise.vue'
import vueConfirmationButton from '@coach/js/components/vue-confirmation-button';
const defaultExerciseToAddDetails = {sets: 3, reps: 10, rep_unit: 'x', rest: 30};
export default {
  props: [
    "initialWorkoutGroup",
    "index"
  ],
  components: {
    WorkoutPlanPanelExerciseGroupExercise,
    vueConfirmationButton
  },
  data() {
    return {
      workoutGroup: this.initialWorkoutGroup,
      newExerciseGroupDetails: null,
      sortedExercises: [],
      showAddExerciseModal: false,
      showEditModal: false,
      showSortModal: false,
      // editIsDirty: false,
      ExerciseToAdd: null,
      exerciseToAddDetails: defaultExerciseToAddDetails,
      // showChooseAlternativeMealModal: false,
      // availableMealSettings: [],
      // availableMealSettingOptions: [],
      // mealSettingOptionThresholdPct: 5,
      // lastMealSettingOptionThresholdPct: 5,
      // chosenAlternativeMealSetting: null,
      // availableMealSettingOptionsCount: null,
      // showUpdateMacrosModal: false,
      // mealSettingExists: true,
      // updatedMacros: {
      //   calories: this.initialWorkoutGroup.target_calories,
      //   protein: this.initialWorkoutGroup.target_protein_g,
      //   carbohydrate: this.initialWorkoutGroup.target_carbohydrate_g,
      //   fat: this.initialWorkoutGroup.target_fat_g,
      //   regenerateMeal: false
      // },
      exercise_list_filter: null,
      // show_only_chosen_foods: true
    };
  },
  mounted() {
    // this.getAllFoods();
    // This does way too many calls on load. Let's do it smarter..
    // this.doesMealSettingExist();
    this.newExerciseGroupDetails = {
      "name": this.workoutGroup.name,
      "description": this.workoutGroup.description
    };
  },
  computed: {
    allExercisesSorted: function() {
      return this.$root.allExercisesSorted;
    },
    filteredExercisesSorted: function() {
      var _this = this;
      var exercises = this.$root.allExercisesSorted;

      if (_this.exercise_list_filter !== null) {
        exercises = exercises.filter(function(exercise) {
          return (exercise.name.search(new RegExp(_this.exercise_list_filter, "i")) !== -1);
        });
      }

      return exercises;
    },
    hasExercises: function() {
      return this.workoutGroup.exercises.length >= 1;
    },
    exerciseToAddDetailsValid: function() {
      return !_.isNull(this.exerciseToAddDetails.set)
        && !_.isNull(this.exerciseToAddDetails.rep)
        && !_.isNull(this.exerciseToAddDetails.rep_unit)
        && !_.isNull(this.exerciseToAddDetails.rest);
    },
    totalSets: function() {
      return this.workoutGroup.exercises.reduce(function (accumulator, item) {
        return 0+accumulator + item.pivot.sets;
      }, 0);
    },
    totalReps: function() {
      return this.workoutGroup.exercises.reduce(function (accumulator, item) {
        return 0+accumulator + (item.pivot.reps*item.pivot.sets);
      }, 0);
    },
    totalRest: function() {
      return this.workoutGroup.exercises.reduce(function (accumulator, item) {
        return 0+accumulator + (item.pivot.rest*item.pivot.sets);
      }, 0);
    },
    sortedExercisePivotIds: function() {
      return this.sortedExercises.map(function (a) { return a.pivot.id });
    },
    originalSortedExercisePivotIds: function() {
      return this.workoutGroup.exercises.map(function (a) { return a.pivot.id });
    },
    sortIsDirty: function() {
      return !_.isEqual(this.sortedExercisePivotIds, this.originalSortedExercisePivotIds);
    },
    editIsDirty: function() {
      let workoutGroupDetails = {
        "name": this.workoutGroup.name,
        "description": this.workoutGroup.description
      };
      return !_.isEqual(this.workoutGroupDetails, this.newExerciseGroupDetails);
    },
  },
  methods: {
    exerciseUpdated: function (pivotId) {
      var _this = this;
      // Vue.set(_this.workoutGroup, 'isLoading', true);
      // this.getWorkoutExerciseGroup(this.workoutGroup.id)
      //   .then(function (fresh) {
      //     Object.assign(_this.workoutGroup, fresh);
      //     Vue.set(_this.workoutGroup, 'isLoading', false);
      //     // _this.doesMealSettingExist();
          _this.$emit('workout-group-updated');
        // });
    },
    // getWorkoutExerciseGroup: function (id) {
    //   return axios.get('/api/workout_plan_exercise_groups/' + id)
    //     .then((response) => {
    //         return response.data.data;
    //     });
    // },
    openAddExerciseModal: function () {
      this.showAddExerciseModal = true;
      this.$nextTick(function(){
        this.$refs.exercise_filter_input.focus();
        // document.getElementById('food_filter_input').focus();
      }.bind(this));
    },
    closeAddExerciseModal: function () {
      this.ExerciseToAdd = null;
      this.exerciseToAddDetails = defaultExerciseToAddDetails;
      this.showAddExerciseModal = false;
      this.exercise_list_filter = null;
    },
    chooseExerciseToAdd: function(exercise) {
      this.ExerciseToAdd = exercise;
      this.$nextTick(function(){
          document.getElementById('exercise-to-add-sets').focus();
      }.bind(this));
    },
    addExercise: function () {
      var _this = this;
      // Vue.set(_this.workoutGroup, 'isLoading', true);
      axios.post('/api/workout_plan_exercises/', {
        workout_plan_exercise_group_id: _this.workoutGroup.id,
        exercise_id: _this.ExerciseToAdd.id,
        // position: _this.exerciseToAddDetails.position,
        sets: _this.exerciseToAddDetails.sets,
        reps: _this.exerciseToAddDetails.reps,
        rep_unit: _this.exerciseToAddDetails.rep_unit,
        rest: _this.exerciseToAddDetails.rest,
      }).then(function (response) {
        // Object.assign(_this.meal, response.data.data);
        // _this.exerciseUpdated();
        _this.closeAddExerciseModal();
        _this.$emit('workout-group-updated');

        // Vue.set(_this.workoutGroup, 'isLoading', false);
      });
    },
    removeWorkoutExerciseGroup: function () {
      let _this = this;
      // Vue.set(_this.workoutGroup, 'isLoading', true);
      axios.delete('/api/workout_plan_exercise_groups/'+_this.workoutGroup.id, {})
        .then(function (response) {
          // _this.exerciseUpdated();
          _this.closeEditModal();
          _this.$emit('workout-group-updated');
          // _this.$destroy();
          // _this.closeAddExerciseModal();
          // _this.$emit('exercise-updated');
          // Vue.set(_this.workoutGroup, 'isLoading', false);
        });
    },
    openSortModal: function () {
      this.sortedExercises = this.workoutGroup.exercises;
      this.showSortModal = true;
    },
    closeSortModal: function () {
      this.sortedExercises = [];
      this.showSortModal = false;
    },
    sortChanged: function() {
      // // this.sortIsDirty = true;
      // console.log("Sorted!");
      // console.log(this.sortedExercisePivotIds);
    },
    updateSorting: function () {
      let _this = this;
      axios.post('/api/workout_plan_exercises/sort', {
          'workout_plan_exercise_ids': _this.sortedExercisePivotIds,
      }).then(function (response) {
          // _this.workoutGroup.exercises = _this.sortedExercises;
          _this.$emit('workout-group-updated');
          // console.log(response.data);
          _this.closeSortModal();
      })
      .catch(e => {
        console.log(e);
          _this.errorBag = e.response.data;
          _this.closeSortModal();
      });
    },
    openEditModal: function () {
      this.showEditModal = true;
    },
    closeEditModal: function () {
      this.newExerciseGroupDetails = {
        "name": this.workoutGroup.name,
        "description": this.workoutGroup.description
      };
      this.showEditModal = false;
    },
    updateExerciseGroup: function () {
      let _this = this;
      axios.put('/api/workout_plan_exercise_groups/'+this.workoutGroup.id, {
          'name': _this.newExerciseGroupDetails.name,
          'description': _this.newExerciseGroupDetails.description,
      }).then(function (response) {
          // _this.workoutGroup.name = _this.newExerciseGroupDetails.name;
          // _this.workoutGroup.description = _this.newExerciseGroupDetails.description;
          _this.$emit('workout-group-updated');
          // console.log(response.data);
          _this.closeEditModal();
      })
      .catch(e => {
        console.log(e);
          _this.errorBag = e.response.data;
          _this.closeEditModal();
      });
    },
  },
  watch: {
    initialWorkoutGroup: function(newVal, oldVal) {
      Vue.set(this, "workoutGroup", newVal);
    }
    // meal: function (newVal,oldVal) {
    //     // var old_food_ids = _.map(oldVal.foods, 'id').sort().join('-')
    //     // var new_food_ids = _.map(newVal.foods, 'id').sort().join('-')
    //     // console.log(old_food_ids);
    //     // console.log(new_food_ids);
    //     // // if (!_.isEqual(newVal.foods, oldVal.foods)){
    //     // if (old_food_ids != new_food_ids){
    //     //     // Vue.set(this, 'meal', newVal);
    //     //     this.doesMealSettingExist();
    //     // }
    // },
  }
};
</script>
